<template>
  <div>
    <div ref="optOutQuestion">
      <div id="optOutQuestion" class="application-section">
        <section id="pliOptedOutSection">
          <div class="container is-fluid">
            <p class="disclaimer-poppin">{{componentData.statement}}</p>
            <ChooseQuestion :question="componentData.question"
                            :tab="sections.pliOptedOutSection.tab"
                            :options="componentData.optOutOptions"
                            :existingValue="optedOutOfPli ? componentData.optOutOptions[1].text : componentData.optOutOptions[0].text"
                            @question-answered="pliOptOutAnswered"
                            :isMandatory="true"
                            :isDropdownControlled="optedOutOfPli" /><br />
            <AdditionalRole v-if="!optedOutOfPli && !isFoundationTrainee" :options="componentData.additionalRoleOptions"
                            :helperTextAdditionalRole="componentData.helperForAdditionalRole"
                            :question="componentData.additionalRoleQuestion"
                            :class="{error: $v.insurance.additionalRole.$error}"
                            @question-answered="additionalRoleAnswered"
                            :existingValue="currentRoles"
                            :isMandatory="!optedOutOfPli" />
            <ChooseQuestion :question="componentData.nonWorkingQuestion"
                            :tabindex="sections.pliOptedOutSection.tab"
                            :options="componentData.nonWorkingEmploymentOptions"
                            :existingValue="insurance.selfEmployedCoverForNonWorking
                            ? componentData.nonWorkingEmploymentOptions[1].text : componentData.nonWorkingEmploymentOptions[0].text"
                            @question-answered="(nonWorkingQuestion) => insurance.selfEmployedCoverForNonWorking = nonWorkingQuestion.text"
                            :isMandatory="true"
                            :isDropdownControlled="false"
                            v-if="nonWorkingMemberOptedIntoPli" />
            <div v-if="nonWorkingMemberOptedIntoPli"><span v-html="componentData.nonWorkingQuestionDetails" class="disclaimer-poppin"></span></div>
            <div v-if="optedOutOfPli"><span class="disclaimer-poppin">{{componentData.disclaimer}}</span></div>
            <div v-if="!optedOutOfPli" class="claim-details"><span class="disclaimer-poppin" v-html="componentData.insuranceMessage"></span></div>
          </div>
          <div v-if="!isMobile" class="component-buttons"><button @click="confirm">{{componentData.nextButton}}</button></div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseQuestion from '@/components/ChooseQuestion.vue';
import AdditionalRole from '@/insurance/AdditionalRole.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import '@/styles/application.scss';
import { requiredIf } from 'vuelidate/lib/validators';

export default {
  name: 'OptOutQuestion',
  components: {
    ChooseQuestion,
    AdditionalRole,
  },
  props: {
    componentData: Object,
  },
  data() {
    return {
      insurance: {},
      sections: {
        pliOptedOutSection: { tab: 0 },
      },
    };
  },
  created() {
    this.insurance = this.getInsurance;
  },
  computed: {
    ...mapGetters(['getInsurance', 'isFinalSection', 'hasNonWorkingStatus', 'isFoundationTrainee']),
    ...mapState(['isMobile', 'application']),
    optedOutOfPli() {
      return this.insurance.optedOutOfPli;
    },
    nonWorkingMemberOptedIntoPli() {
      return this.hasNonWorkingStatus && !this.optedOutOfPli;
    },
    currentRoles() {
      return this.insurance.additionalRole.split(';');
    },
  },
  methods: {
    ...mapActions(['savePliOptOutData']),
    pliOptOutAnswered(opt) {
      this.insurance.optedOutOfPli = opt.text === this.componentData.optOutOptions[1].text;
    },
    additionalRoleAnswered(a) {
      this.insurance.additionalRole = a.join(';');
      this.$v.insurance.additionalRole.$touch();
    },
    confirm() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.$nextTick(() => {
          // - 100 is offset because of Sticky positional DNN header.
          window.scrollTo(0, (document.querySelector('.error').getBoundingClientRect().top - 100) + window.pageYOffset);
        });
        return;
      }
      this.savePliOptOutData(this.insurance);
      this.$emit('completed', {
        process: this.componentData.process,
        optedOut: this.optedOutOfPli,
      });
    },
  },
  validations() {
    return {
      insurance: {
        additionalRole: {
          required: requiredIf(() => !this.optedOutOfPli && !this.isFoundationTrainee),
        },
      },
    };
  },
  async HasErrorInSection(currentSection) {
    if (currentSection === 'pliOptedOutSection') {
      this.$v.insurance.additionalRole.$touch();
      return this.$v.insurance.additionalRole.$error;
    }
    return false;
  },
};
</script>
<style lang="scss">
  @import '../styles/_mixins.scss';

  #pliOptedOutSection {
    div > span.disclaimer-poppin {
      text-align: justify;
      font-size: 12pt;
      @include DefaultPoppinFont();
    }

    div.claim-details {
      margin-top: 20px;
      font-size: 18px;

      span.disclaimer-poppin {
        @include DefaultPoppinFont();
      }

      p.disclaimer-poppin {
        @include DefaultPoppinFont();
      }
    }
  }
</style>
